import React from "react";
import Select from 'react-select';

const ReactSelectOption = props => {
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
            ? '#1081E8'
            : isFocused
              ? '#e7f2fa'
              : null,
        color: isDisabled
          ? '#ccc'
          : isSelected
            ? 'white'
            : '#5d6164',
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled && (isSelected ? '#6ab0de' : '#6ab0de')
        }
      };
    },
    menu: provided => ({ ...provided, zIndex: 9 })
  };
  return <Select
    className={`basic-single ${props.className ? props.className : ""} ${props.isInvalidSubmit && (props.value === null || props.value === undefined || props.value === false || props.value === "") || props.isInvalidField ? "select-fail" : ""}`}
    classNamePrefix="cryllex-select"
    placeholder={props.placeholder}
    name={props.name}
    defaultValue={props.defaultValue}
    value={props.selectedValue}
    options={props.items}
    isDisabled={props.isDisabled}
    isSearchable={true}
    onChange={props.onChange}
    styles={colourStyles}
    onFocus={props.onFocus}
    maxMenuHeight={300}
  />
}

export default ReactSelectOption;